export default __webpack_public_path__ + "locales/hy-AM/EmbeddingPanel.json?hash=a1eae15d1c52e0b345765f59bf93fb9b";